





























































































































































































































































import Vue, { VueConstructor } from "vue"
import { FormSubmissionMixin } from "@/mixins/formSubmissionMixin"
import { AutofillFirmInfoMixin } from "@/mixins/autofillFirmInfo"
import { policyCancellationForm } from "@/constants/policyChangeForms"
import Form from "../Forms/Form.vue"
import FormSection from "../Forms/FormSection.vue"
import FormSectionContent from "../Forms/FormSectionContent.vue"
import FormRow from "../Forms/FormRow.vue"
import TextInput from "../../TextInput.vue"
import FormStateSelect from "../Forms/FormStateSelect.vue"
import FormDatePicker from "../Forms/FormDatePicker.vue"
import YesNoRadioGroup from "../../YesNoRadioGroup.vue"
import FormContent from "../Forms/FormContent.vue"
import FormBody from "../Forms/FormBody.vue"
import FormDetail from "../Forms/FormDetail.vue"

export default (Vue as VueConstructor<Vue & typeof FormSubmissionMixin & typeof AutofillFirmInfoMixin>).extend({
  components: {
    Form,
    FormSection,
    FormSectionContent,
    FormRow,
    TextInput,
    FormStateSelect,
    FormDatePicker,
    YesNoRadioGroup,
    FormContent,
    FormBody,
    FormDetail,
  },
  mixins: [FormSubmissionMixin, AutofillFirmInfoMixin()],
  data: () => ({
    formToSubmit: policyCancellationForm,
    userSubmissionForm: {
      type: "policyCancellation",
      description: "Request for Policy Cancellation",
      items: {
        firmname: null,
        policykey: null,
        requestedcancellationdate: null,
        reasonfirmdissolving: null,
        reasonretiring: null,
        reasonleavingpractice: null,
        additionalinformation: null,
        reasonmoveoutofnc: null,
        reasonjoinanotherfirm: null,
        newfirmname: null,
        reasondeceased: null,
        reasonother: null,
        forwardingstreetorpobox: null,
        forwardingcity: null,
        forwardingstate: null,
        forwardingzip: null,
        forwardingphonenumber: null,
        forwardingemail: null,
        signature: {
          partnersigndate: null,
          partnersignature: null,
        },
      },
    },
  }),
})
